import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy URL → current canonical page
export const Route = createFileRoute("/tech-support-montclair")({
  beforeLoad: () => {
    throw redirect({ to: "/tech-support-montclair-ca", statusCode: 301 });
  },
});
